import React, { Fragment, useState } from "react"
import { Link } from "gatsby"
import clsx from "clsx"

import { useLocale } from "context/locale"
import useResponsive from "hooks/useResponsive"

import { getAnimatedIcon } from "utils"

import IcoArrow from "assets/icons/header-arrow.svg"

const ServicesSubmenu = ({
  services,
  submenu,
  setSubmenu,
  isServicesSubmenu,
  onClick,
}) => {
  const { t } = useLocale()
  const { isDesktop } = useResponsive()

  const [tab, setTab] = useState(services ? services[0].name : "")

  return (
    services && (
      <div className="header__services-submenu">
        <div className="row g-0">
          {!isServicesSubmenu && (
            <div className="col-xl-6">
              <div className="header__services-submenu-tabs">
                {services.map(service => (
                  <button
                    key={service.name}
                    className={clsx(
                      isDesktop && tab === service.name && "current"
                    )}
                    onClick={
                      !isDesktop ? () => setSubmenu(service.name) : undefined
                    }
                    onMouseEnter={
                      isDesktop ? () => setTab(service.name) : undefined
                    }
                  >
                    <strong>
                      {service.name}
                      <span className="header__nav-arrow">
                        <img src={IcoArrow} alt="" />
                      </span>
                    </strong>
                    <span>{service.description}</span>
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="col-xl-6">
            <div className="header__services-submenu-nav">
              {services.map(service => (
                <Fragment key={service.name}>
                  {((isDesktop && tab === service.name) ||
                    (!isDesktop && submenu === service.name)) && (
                    <>
                      {service.services.nodes
                        ?.sort((a, b) => {
                          const a_order = a?.acfServices?.servicesOrder?.menu
                          const b_order = b?.acfServices?.servicesOrder?.menu

                          if (a_order && b_order) {
                            return a_order - b_order
                          } else {
                            return a.title > b.title ? 1 : -1
                          }
                        })
                        .map(item => {
                          const icon = getAnimatedIcon(
                            item.title,
                            item.acfServices.aboutHero.icon?.sourceUrl
                          )

                          return (
                            <Link
                              key={item.title}
                              to={`${t("/services/")}${item.slug}`}
                              onClick={onClick}
                            >
                              <span>
                                {icon && typeof icon === "object" ? (
                                  icon
                                ) : (
                                  <img src={icon} alt="" />
                                )}
                              </span>
                              {item.title}
                            </Link>
                          )
                        })}
                    </>
                  )}
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default ServicesSubmenu
